import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import CreditCardIcon from 'components/ReusableComponents/CreditCardIcon'
import AddIcon from 'components/ReusableComponents/Icons/Add'
import ExclamationIcon from 'components/ReusableComponents/Icons/Exclamation'
import { useState } from 'react'

import { ReactComponent as ACHIcon } from './ACH.svg'
// accountHolderName
// :
// "Celebration PH Holdings LTD"
// bankName
// :
// "BANK OF NEW YORK MELLON"
// friendlyDisplayName
// :
// "BANK OF NEW YORK MELLON-5167"
// isDefaultAccount
// :
// false
// last4
// :
// "5167"
// method
// :
// "Check"
// network
// :
// "US"
// paymentAccountId
// :
// 436
import styles from './PaymentMethodsDialog.module.scss'

const PaymentMethodCard = ({
  isDefaultAccount,
  last4,
  method,
  network,
  friendlyDisplayName,
  isExpired,
  expirationDate,
  onSelect,
  onClickMakeDefault,
  onClickDelete,
  onClickEdit
}) => {
  const [isDeleteConfirmationVisible, setIsDeleteConfirmationVisible] = useState(false)

  if (isDeleteConfirmationVisible) {
    return (
      <ConfirmationDialog
        title={`Do you really want to remove ${network} ending in ${last4}`}
        hasDangerousAction
        positiveMessage="Yes, remove this card"
        negativeMessage="Go back"
        onClose={() => setIsDeleteConfirmationVisible(false)}
        onConfirm={() => onClickDelete()}
      >
        <p>This action cannot be undone.</p>
      </ConfirmationDialog>
    )
  }

  return (
    <>
      <div className={isExpired ? styles.card : styles.cardClickable}>
        <button
          className={styles.cardClickArea}
          onClick={isExpired ? () => null : onSelect}
        >
          <div className={styles.icon}>
            {method === 'CreditCard' && <CreditCardIcon type={network} />}
            {method === 'Check' && <ACHIcon className={styles.achIcon} />}
            {method === 'ACH' && <ACHIcon className={styles.achIcon} />}
          </div>
          <div className={styles.paymentMethodTexts}>
            <div className={styles.primaryText}>
              {method === 'CreditCard' && (
                <>
                  <strong>{network}</strong> ending in {last4}
                </>
              )}
              {method === 'Check' && (
                <>
                  <strong>E-check</strong>
                </>
              )}
              {method === 'ACH' && (
                <>
                  <strong>E-check</strong>
                </>
              )}
            </div>
            <div className={styles.secondaryText}>
              {method === 'CreditCard' && !isExpired && <>Expires {expirationDate}</>}
              {method === 'CreditCard' && isExpired && (
                <span className={styles.expiredText}>
                  <ExclamationIcon /> Expired
                </span>
              )}
              {method === 'Check' && <>{friendlyDisplayName}</>}
              {method === 'ACH' && <>{friendlyDisplayName}</>}
            </div>
          </div>
        </button>
        <div className={styles.controls}>
          {isDefaultAccount && !isExpired && (
            <p className={styles.defaultMethodText}>Default method</p>
          )}
          {isExpired && (
            <>
              <button className={styles.control} onClick={onClickEdit}>
                Update
              </button>
              <button
                className={styles.control}
                onClick={() => setIsDeleteConfirmationVisible(true)}
              >
                Remove
              </button>
            </>
          )}
          {!isExpired && !isDefaultAccount && (
            <button className={styles.control} onClick={onClickMakeDefault}>
              Make default
            </button>
          )}
        </div>
      </div>
    </>
  )
}

const PaymentMethodsDialog = ({
  savedPaymentMethods,
  onSelect,
  onClose,
  makeMethodDefault,
  deleteMethod,
  setCardIdToEdit
}) => (
  <ConfirmationDialog
    title="Use a saved payment method"
    theme="blacklist"
    maxWidth={540}
    onClose={onClose}
    hasConfirmButton={false}
  >
    <div className={styles.cards}>
      {savedPaymentMethods.map(m => (
        <PaymentMethodCard
          key={m.paymentAccountId}
          accountHolderName={m.accountHolderName}
          bankName={m.bankName}
          isDefaultAccount={m.isDefaultAccount}
          last4={m.last4}
          method={m.method}
          network={m.network}
          paymentAccountId={m.paymentAccountId}
          friendlyDisplayName={m.friendlyDisplayName}
          onSelect={() => onSelect(m.paymentAccountId)}
          isExpired={m.isExpired}
          expirationDate={m.expirationDate}
          onClickMakeDefault={() => makeMethodDefault(m.paymentAccountId)}
          onClickDelete={() => deleteMethod(m.paymentAccountId)}
          onClickEdit={() => setCardIdToEdit(m.paymentAccountId)}
        />
      ))}
    </div>
    <button className={styles.newMethodButton} onClick={onClose}>
      <AddIcon />
      Add a new credit card or e-check
    </button>
  </ConfirmationDialog>
)

export default PaymentMethodsDialog
